import { LoadingSpinner } from "@/core/components/loading-spinner";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";

export const ProjectionBuildLoadingState = () => (
  <Stack
    align="center"
    justify="center"
    gap="md"
    fullWidth
    className="min-h-0 flex-1 px-6 py-16 text-center"
  >
    <LoadingSpinner containerClassName="h-auto" />
    <Typography variant="bodyW3" textColor="secondary">
      We're crunching the numbers. Your PayPacks will appear when they're ready.
      This may take a few seconds.
    </Typography>
  </Stack>
);
